module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [(_vm.apiErrorI18nKey) ? _c('div', {
    staticClass: "alert alert-danger mt-3",
    attrs: {
      "role": "alert"
    }
  }, [_c('b', [_vm._v("更新メッセージ")])]) : _vm._e(), _vm._v(" "), _c('page-form', {
    attrs: {
      "family_relations": _vm.family_relations,
      "child_infos": _vm.child_infos
    },
    on: {
      "tryForm": _vm.tryForm,
      "remove": _vm.remove
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19e78c5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/MyPage/ChildInfo.vue
// module id = 674
// module chunks = 0